
<template>
  <div>
     <div class="formBox" ref="searchBox">
      <el-form :inline="true"  class="demo-form-inline" label-width="110px" size="mini">
         <div class="formItemBox">
          <el-form-item label="捆包编号:" class="">
            <el-input placeholder="可支持多个" type="textarea" v-model="searchFrom.cargoBarcode"></el-input>
          </el-form-item>
          <template v-for="(column,index) in searchList" >
              <el-form-item label="结算客户:" v-if="column.enName=='payee'&&(index<seacrchNum||topShow)" :key="column.enName">
                <el-select  v-model="searchFrom.payee" filterable allow-create placeholder="请选择" @focus="jskhFocus">
                  <el-option  label="全部" value="" ></el-option>
                  <el-option v-for="item in kehuList" :label="item.payee" :value="item.payee" :key="item.payee"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="运单编号:" class="item1" v-else-if="column.enName=='wayNo'&&(index<seacrchNum||topShow)" :key="column.enName" >
                  <el-input placeholder="可支持多个" type="textarea" v-model="searchFrom.wayNo" ></el-input>
              </el-form-item>
              <el-form-item label="订单编号:" v-else-if="column.enName=='orderNo'&&(index<seacrchNum||topShow)" :key="column.enName" class="item1">
                <el-input placeholder="可支持多个" type="textarea" v-model="searchFrom.ddbh"></el-input>
              </el-form-item>
              <el-form-item label="货物类型:" v-else-if="column.enName=='productTypeName'&&(index<seacrchNum||topShow)" :key="column.enName">
                <el-select  v-model="searchFrom.productTypeName" filterable placeholder="请选择">
                  <el-option  label="全部" value="" ></el-option>
                  <el-option v-for="item in HWlist" :label="item.showName" :value="item.showName" :key="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="司机归属:"  v-else-if="column.enName=='driverOwnershipName'&&(index<seacrchNum||topShow)" :key="column.enName">
                <el-select v-model="searchFrom.driverOwnershipName" placeholder="请选择">
                  <el-option label="全部" value="" ></el-option>
                  <el-option label="自有" value="自有" ></el-option>
                  <el-option label="外协" value="外协" ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="车船归属:"  v-else-if="column.enName=='vehicleOwnershipName'&&(index<seacrchNum||topShow)" :key="column.enName">
                <el-select v-model="searchFrom.vehicleOwnershipName" placeholder="请选择">
                  <el-option label="全部" value="" ></el-option>
                  <el-option label="自有" value="自有" ></el-option>
                  <el-option label="外协" value="外协" ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="承运商/部门:" v-else-if="column.enName=='generalCarrier'&&(index<seacrchNum||topShow)" :key="column.enName">
                <el-select  v-model="searchFrom.generalCarrier" filterable placeholder="请选择">
                  <el-option v-for="item in CYSList" :label="item.generalCarrier" :value="item.generalCarrier" :key="item.generalCarrier"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="运单状态:" v-else-if="column.enName=='wayStateName'&&(index<seacrchNum||topShow)" :key="column.enName">
                <el-select v-model="searchFrom.wayStateArr" multiple  placeholder="请选择" >
                  <!-- <el-option label="全部" value="" ></el-option> -->
                  <el-option label="待配载" value="0" ></el-option>
                  <el-option label="待装车" value="1" ></el-option>
                  <el-option label="运输中" value="2" ></el-option>
                  <el-option label="待签收" value="3" ></el-option>
                  <el-option label="已签收" value="4" ></el-option>
                  <!-- <el-option label="已作废" value="5" ></el-option> -->
                </el-select>
              </el-form-item>
              <el-form-item label="网货状态:" v-else-if="column.enName=='onlinePushStatusName'&&(index<seacrchNum||topShow)" :key="column.enName">
                <el-select v-model="searchFrom.onlineAddPushFlag"   placeholder="请选择" >
                  <el-option label="全部" value="全部" ></el-option>
                  <el-option label="不推送风控平台" value="不推送风控平台" ></el-option>
                  <el-option label="风控平台推送中" value="风控平台推送中" ></el-option>
                  <el-option label="已推送风控平台" value="已推送风控平台" ></el-option>
                  <el-option label="风控平台推送失败" value="风控平台推送失败" ></el-option>
                  <el-option label="已推送三方网货" value="已推送三方网货" ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="能源类型:" v-else-if="column.enName=='energyTypeName'&&(index<seacrchNum||topShow)" :key="column.enName">
                <el-select v-model="searchFrom.energyTypeName" placeholder="请选择">
                  <el-option label="全部" value="" ></el-option>
                  <el-option label="******" value="******" ></el-option>
                  <el-option label="其他" value="其他" ></el-option>
                  <el-option label="汽油" value="汽油" ></el-option>
                  <el-option label="柴油" value="柴油" ></el-option>
                  <el-option label="天然气" value="天然气" ></el-option>
                  <el-option label="电" value="电" ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="配载重量:" v-else-if="column.enName=='dispatchWeightNum'&&(index<seacrchNum||topShow)" :key="column.enName">
                <el-input placeholder="" v-number-input.float="3" v-model="searchFrom.dispatchWeightT" ></el-input>
              </el-form-item>
              <el-form-item label="结算量:" v-else-if="column.enName=='liquidatedAmountNum'&&(index<seacrchNum||topShow)" :key="column.enName">
                <el-input placeholder=""  v-number-input.float="3" v-model="searchFrom.liquidatedAmount" ></el-input>
              </el-form-item>
               <el-form-item label="卸车量:" v-else-if="column.enName=='unloadingsNum'&&(index<seacrchNum||topShow)" :key="column.enName">
                <el-input placeholder="" v-number-input.float="3" v-model="searchFrom.unloadings" ></el-input>
              </el-form-item>
               <el-form-item label="创建时间:" class="item2" v-else-if="column.enName=='createTime'&&(index<seacrchNum||topShow)" :key="column.enName">
                <el-date-picker
                    v-model="searchFrom.createTimes"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :default-time="['00:00:00', '23:59:59']"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="实际签收时间:" class="item2" v-else-if="column.enName=='actualSigningTime'&&(index<seacrchNum||topShow)" :key="column.enName">
                <el-date-picker
                    v-model="searchFrom.actualSigningTime"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :default-time="['00:00:00', '23:59:59']"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="实际装车时间:" class="item2" v-else-if="column.enName=='actualLoadingTime'&&(index<seacrchNum||topShow)" :key="column.enName">
                <el-date-picker
                    v-model="searchFrom.actualLoadingTime"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :default-time="['00:00:00', '23:59:59']"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="业务部门:"  v-else-if="column.enName=='businessSubunit'&&(index<seacrchNum||topShow)" :key="column.enName">
                <el-select  v-model="searchFrom.businessSubunit" filterable placeholder="请选择" @change="bumenChangeCX">
                  <el-option  label="全部" value="" ></el-option>
                  <el-option v-for="item in bumenList" :label="item.name" :value="item.name" :key="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="业务人员:"  v-else-if="column.enName=='businessUser'&&(index<seacrchNum||topShow)" :key="column.enName">
                <el-select  v-model="searchFrom.businessUser" filterable placeholder="请选择">
                  <el-option  label="全部" value="" ></el-option>
                  <el-option v-for="item in yonghuList" :label="item.userName" :value="item.userName" :key="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="业务类型:"  v-else-if="column.enName=='wayBusinessTypeName'&&(index<seacrchNum||topShow)" :key="column.enName">
                <el-select v-model="searchFrom.wayBusinessType" placeholder="请选择">
                  <el-option  label="全部" value="" ></el-option>
                  <el-option v-for="item in YWLXlist" :label="item.showName" :value="item.itemNo" :key="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="是否往返:"  v-else-if="column.enName=='arriveDepartFlag'&&(index<seacrchNum||topShow)" :key="column.enName">
                <el-select v-model="searchFrom.arriveDepartFlag" placeholder="请选择">
                  <el-option label="全部" value="" ></el-option>
                  <el-option label="是" value="是" ></el-option>
                  <el-option label="否" value="否" ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="超时报警:"  v-else-if="column.enName=='timeoutReminder'&&(index<seacrchNum||topShow)" :key="column.enName">
                <el-select v-model="searchFrom.timeoutReminder" placeholder="请选择">
                  <el-option label="全部" value="" ></el-option>
                  <el-option label="装车超时" value="1" ></el-option>
                  <el-option label="卸车超时" value="2" ></el-option>
                  <el-option label="签收超时" value="3" ></el-option>
                </el-select>
              </el-form-item>
               <el-form-item label="收入结算状态:"  v-else-if="column.enName=='ysSettlementStatesName'&&(index<seacrchNum||topShow)" :key="column.enName">
                <el-select v-model="searchFrom.ysSettlementStates" placeholder="请选择结算状态">
                  <el-option v-for="item in ysSettlementList" :label="item.showName" :key="item.value"
                    :value="item.value"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="收入开票状态:"  v-else-if="column.enName=='ysInvoicingStatesName'&&(index<seacrchNum||topShow)" :key="column.enName">
                <el-select v-model="searchFrom.ysInvoicingStates" placeholder="请选择开票状态">
                  <el-option v-for="item in ysInvoicingList" :label="item.showName" :key="item.showName" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="装车量:"  v-else-if="column.enName=='truckloadNum'&&(index<seacrchNum||topShow)" :key="column.enName">
                <el-input  placeholder=""  v-number-input.float="3"    maxlength="8"  v-model="searchFrom.truckload"></el-input>
              </el-form-item>
               <el-form-item label="推送首钢:"  v-else-if="column.enName=='pl3PushFlag'&&(index<seacrchNum||topShow)" :key="column.enName">
                <el-select v-model="searchFrom.pl3PushFlag" placeholder="请选择">
                  <el-option label="全部" value="" ></el-option>
                  <el-option label="是" :value="0" ></el-option>
                  <el-option label="否" :value="1" ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="运输方式:"  v-else-if="column.enName=='transportModeName'&&(index<seacrchNum||topShow)" :key="column.enName">
                <el-select v-model="searchFrom.transportMode" placeholder="请选择">
                  <el-option label="全部" value="" ></el-option>
                  <el-option label="汽运" :value="1" ></el-option>
                  <el-option label="海运" :value="2" ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="收入结算状态:"  v-else-if="column.enName=='ysSettlementStatesName'&&(index<seacrchNum||topShow)" :key="column.enName">
                <el-select v-model="searchFrom.ysSettlementStates" placeholder="请选择结算状态">
                  <el-option v-for="item in ysSettlementList" :label="item.showName" :key="item.value"
                    :value="item.value"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="收入开票状态:"  v-else-if="column.enName=='ysInvoicingStatesName'&&(index<seacrchNum||topShow)" :key="column.enName">
                <el-select v-model="searchFrom.ysInvoicingStates" placeholder="请选择开票状态">
                  <el-option v-for="item in ysInvoicingList" :label="item.showName" :key="item.showName" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
               <template v-else >
                  <el-form-item :label="column.cnName+':'"  :key="column.enName" v-if="(index<seacrchNum||topShow)">
                    <el-input placeholder="" v-model="searchFrom[column.enName]" ></el-input>
                  </el-form-item>
               </template>

          </template>
          <el-form-item label="合约编号:" >
            <el-input placeholder="" v-model="searchFrom.agreementNumber" ></el-input>
          </el-form-item>
        </div>
        <div style="display: flex;justify-content: space-between;align-items: center;padding-right: 20px;">
          <div class="searchBtnBox">
            <el-button type="primary" v-if="btnFlg[0]" size="mini" @click="searchFn">查询</el-button>
            <el-button type="primary"  size="mini" @click="resetForm('searchFrom')">重置</el-button>
             <el-button type="primary" v-if="btnFlg[1]"  size="mini" @click="exportFn" :disabled="isDisable">导出</el-button>
            <el-button type="primary" v-if="btnFlg[2]" size="mini" @click="huifuFn">运单恢复</el-button>
          </div>
          <div @click="tabSetting"><i class="el-icon-s-tools"></i></div>
        </div>
      </el-form>
    </div>
    <div class="openBox">
      <div class="openChild" v-if="topShow" @click="topFn">
        <i class="el-icon-caret-top" ></i>
      </div>
      <div class="openChild" v-if="!topShow" @click="topFn">
        <i class="el-icon-caret-bottom" ></i>
      </div>
    </div>
    <!-- 表格 -->
    <div :style="{height:h}">
     <el-table :data="tableList" v-if="tabHeadList.length>0"  ref="table" v-loading="loading"   bordersize="mini"  @selection-change='selectGoods'
       @row-click="handleRowClick"  style="width: 100%" height="100%"  center border :cell-class-name="myclass" :cell-style="getCellStyle" >
       <el-table-column type="selection" width="55" fixed></el-table-column>
       <el-table-column  type="index" width="55" label="序号" fixed></el-table-column>
        <template v-for="(column,index) in tabHeadList">
          <template v-if="column.enName=='wayNo'">
            <el-table-column property=""  width="240" label="运单编号" :fixed="index<1" :key="column.enName">
              <template slot-scope="scope">
                <span class="textColer" @click="detailFn(scope.row)">{{scope.row.wayNo}}</span>
              </template>
            </el-table-column>
          </template>
          <template v-else-if="column.enName=='weightDifferenceRate'">
            <el-table-column property=""  width="100" label="磅差率(‰)" :fixed="index<1" :key="column.enName">
              <template slot-scope="scope">
                <span  v-if="(-3<scope.row.weightDifferenceRate)&&(scope.row.weightDifferenceRate<3)" >{{scope.row.weightDifferenceRate}}</span>
                <span style="color: #D51212;" v-else >{{scope.row.weightDifferenceRate?scope.row.weightDifferenceRate:'-'}}</span>
              </template>
            </el-table-column>
          </template>
          <!--  <template v-else-if="column.enName=='whAuditStatusName'">
            <el-table-column property=""  width="120" label="网货提示" :fixed="index<2"  :key="column.enName">
              <template slot-scope="scope">
                <span v-if="scope.row.onlineAddPushrlag==3">>
                  {{scope.row.onlineMessage?scope.row.onlineMessage:'-'}}
                </span>
                <span v-else-if="scope.row.onlineUpdateTimes==3">
                  {{scope.row.onlineMessage}}
                </span>
                <span v-else>
                  <span style="color: #0c46a2;cursor: pointer;" @click="shenhejiluFn(scope.row)" v-if="scope.row.auditStatus==1||scope.row.auditStatus==2"
                  >{{scope.row.whAuditStatusName}}</span>
                  <span  v-else >{{scope.row.whAuditStatusName?scope.row.whAuditStatusName:'-'}}</span>
                </span>
              </template>
            </el-table-column>
          </template> -->
          <template v-else-if="column.enName=='wayStateName'">
            <el-table-column property=""  width="100" label="状态" :fixed="index<1" :key="column.enName">
              <template slot-scope="scope">
                <span style="color: #E99D42;" v-if="scope.row.wayState==2" >{{scope.row.wayStateName}}</span>
                <span style="color: #D51212;" v-else-if="scope.row.wayState==3" >{{scope.row.wayStateName}}</span>
                <span style="color: #81B337;" v-else-if="scope.row.wayState==4" >{{scope.row.wayStateName}}</span>
                <span style="color: #9A9A9A;" v-else-if="scope.row.wayState==5" >{{scope.row.wayStateName}}</span>
                <span  v-else >{{scope.row.wayStateName}}</span>
              </template>
            </el-table-column>
          </template>

          <template v-else>
            <el-table-column :key="column.enName" :prop="column.enName" :label="column.cnName" :fixed="index<1" :width="column.fieldWidth" show-overflow-tooltip :formatter="formatterRowEmpty">
              <template v-for="item in column.child">
                <el-table-column property="" v-if="item.enName=='revenueSurcharge'"  width="150" label="收入附加费(元)" :key="item.enName">
                  <template slot-scope="scope">
                    <span style="color: #81B337;" v-if="scope.row.revenueSurcharge>0" >{{scope.row.revenueSurcharge}}</span>
                    <span style="color: #D51212;" v-else-if="scope.row.revenueSurcharge<0" >{{scope.row.revenueSurcharge}}</span>
                    <span v-else >{{scope.row.revenueSurcharge}}</span>
                  </template>
                </el-table-column>
                <el-table-column property="" v-else-if="item.enName=='disburseSurcharge'"  width="150" label="支出附加费(元)" :key="item.enName">
                  <template slot-scope="scope">
                    <span style="color: #81B337;" v-if="scope.row.disburseSurcharge>0" >{{scope.row.disburseSurcharge}}</span>
                    <span style="color: #D51212;" v-else-if="scope.row.disburseSurcharge<0" >{{scope.row.disburseSurcharge}}</span>
                    <span v-else >{{scope.row.disburseSurcharge?scope.row.disburseSurcharge:'-'}}</span>
                  </template>
                </el-table-column>
                <el-table-column v-else :key="item.enName" :prop="item.enName" :label="item.cnName"  :width="item.fieldWidth" show-overflow-tooltip :formatter="formatterRowEmpty">
                </el-table-column>
              </template>
            </el-table-column>
          </template>
        </template>
      </el-table>
    </div>
    <!-- 分页 -->
    <div>
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[50,100,200,500]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
    <!-- 设置表头 -->
    <table-heads v-if="tableMark" :tableMark.sync='tableMark' :groupCode="groupCode" @refresh = 'queryMyPageField'></table-heads>
    <export-setting v-if="exportMark" :exportMark.sync='exportMark' :groupCode="groupCode"
   @exportList='exportList'></export-setting>
  </div>
</template>

<script>
import { getBtn } from '@/utils/getButton'
import { getDictionaryDetailList, findCustomerInfoList, findRecycleWayList, queryMyPageField, findWayPayeeList, findSonSectionList, wayRevert } from '@/api/newTMS'
import { getCurrUserDepartment, getDepartmentUsers } from '@/api/newCrm'
import { formatterRowEmpty, dateTimeFormat, dateFormat } from '@/utils/util'
import { exportExcel } from '@/utils/fileDownXlsx.js'
import tableHeads from '@/views/newTMS/publicFiles/tableHeades.vue'
import exportSetting from '@/views/newTMS/publicFiles/exportSetting.vue'
export default {
  components: {
    tableHeads, exportSetting
  },
  data () {
    return {
      groupCode: 'platformWay',
      tableMark: false,
      exportMark: false,
      tabHeadList: [],
      formatterRowEmpty: formatterRowEmpty,
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      h: 500,
      searchFrom: {
        pageNo: 1,
        pageSize: 50
        // orderStates: '0,1'
      },
      tableList: [],
      total: 0,
      loading: false,
      btnFlg: [],
      btnIdArr: ['01N01D0300', '01N01D0400', '01N01D0500'],
      kehuList: [],
      isDisable: false,
      customTypes: [],
      importDialog: false,
      CYSList: [], // 承运商
      yonghuList: [],
      zidanList: [],
      SRJJlist: [],
      userName: localStorage.getItem('userName'),
      usertype: null,
      HWlist: [], // 货物名称
      bumenList: [],
      ysSettlementList: [
        {
          showName: '全部',
          value: ''
        },
        {
          showName: '未对账',
          value: '-1'
        },
        {
          showName: '未收款',
          value: '0'
        },
        {
          showName: '部分收款',
          value: '1'
        },
        {
          showName: '已收款',
          value: '2'
        }
      ],
      ysInvoicingList: [
        {
          showName: '全部',
          value: ''
        },
        {
          showName: '待申请',
          value: '0'
        },
        {
          showName: '部分开票',
          value: '1'
        },
        {
          showName: '待开票',
          value: '11'
        },
        {
          showName: '已开票',
          value: '2'
        }
      ],
      searchList: [],
      topShow: false,
      seacrchNum: window.innerWidth > 1680 ? 8 : 6
    }
  },
  created () {
    if (this.$route.params) {
      this.$set(this.searchFrom, 'orderNo', this.$route.params.orderNo)
    }
    this.btnFlg = getBtn(this.btnIdArr, '/recycleBin')
    this.getList(this.searchFrom)
    getDictionaryDetailList({ dictionaryType: 'goods_type' }).then(res => { this.HWlist = res })
    getDictionaryDetailList({ dictionaryType: 'business_type' }).then(res => { this.YWLXlist = res })
    getDictionaryDetailList({ dictionaryType: 'settlement_pricing' }).then(res => { this.SRJJlist = res })
    findCustomerInfoList({ businessType: 1 }).then(res => { this.kehuList = res })
    getCurrUserDepartment().then(res => { this.bumenList = res })
    this.queryMyPageField()
  },

  mounted () {

  },
  methods: {
    // 运单恢复
    huifuFn () {
      let selectData = this.$refs.table.selection
      if (selectData.length == 0) {
        this.$alert('请选择要操作的数据', '系统提示')
        return
      }
      if (selectData.length > 10) {
        this.$alert('最多只能选择10条数据', '系统提示')
        return
      }
      let arr = selectData.map(item => item.wayId)
      this.$confirm('是否执行运单恢复操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        wayRevert({
          wayIds: arr
        }).then(res => {
          loading.close()
          this.$message({
            message: '操作成功',
            type: 'success'
          })
          this.getList(this.searchFrom)
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    getHeight () {
      this.$nextTick(() => {
        let h = this.$refs.searchBox.offsetHeight
        let pH = document.documentElement.clientHeight
        this.h = (pH - h - 210) + 'px'
      })
    },
    topFn () {
      this.topShow = !this.topShow
      this.getHeight()
      this.seacrchNum = window.innerWidth > 1680 ? 8 : 6
    },
    bottomFn () {
      this.topShow = true
      this.$nextTick(() => {
        let h = this.$refs.searchBox.offsetHeight
        let pH = document.documentElement.clientHeight
        this.h = (pH - h - 110) + 'px'
      })
    },
    // 修改单元格样式的方法
    myclass ({ row, column, rowIndex, columnIndex }) {
      if (column.label == '网货提示') {
        if (row.onlineMessage) {
          return 'warning-row'
        } else {
          return ''
        }
      }
    },
    // 结算客户获取焦点
    jskhFocus () {
      this.getkehuFn()
    },
    // 报警颜色设置
    getCellStyle ({ row, column, rowIndex, columnIndex }) {
      if (column.label == '超时报警') {
        if (row.timeoutReminder == '装车超时') {
          return { color: '#FEB0A4' }
        } else if (row.timeoutReminder == '卸车超时') {
          return { color: '#FDCC0F' }
        } else if (row.timeoutReminder == '签收超时') {
          return { color: 'red' }
        } else {
          return { }
        }
      }
    },

    // 获取结算客户
    getkehuFn () {
      if (this.searchFrom.wayNo) {
        let wayNoStr = this.searchFrom.wayNo.trim()
        this.searchFrom.wayNos = wayNoStr.replace(/\n/g, ',')
      } else {
        this.searchFrom.wayNos = ''
      }
      if (this.searchFrom.ddbh) {
        let ddhStr = this.searchFrom.ddbh.trim()
        this.searchFrom.orderNos = ddhStr.replace(/\n/g, ',')
      } else {
        this.searchFrom.orderNos = ''
      }
      if (this.searchFrom.cargoBarcode) {
        let kbhStr = this.searchFrom.cargoBarcode.trim()
        this.searchFrom.cargoBarcodes = kbhStr.replace(/\n/g, ',')
      } else {
        this.searchFrom.cargoBarcodes = ''
      }
      if (this.searchFrom.createTimes) {
        this.searchFrom.createTimeStart = this.searchFrom.createTimes[0]
        this.searchFrom.createTimeEnd = this.searchFrom.createTimes[1]
      } else {
        this.searchFrom.createTimeStart = ''
        this.searchFrom.createTimeEnd = ''
      }
      if (this.searchFrom.actualSigningTime) {
        this.searchFrom.actualSigningTimeStart = this.searchFrom.actualSigningTime[0]
        this.searchFrom.actualSigningTimeEnd = this.searchFrom.actualSigningTime[1]
      } else {
        this.searchFrom.actualSigningTimeStart = ''
        this.searchFrom.actualSigningTimeEnd = ''
      }
      if (this.searchFrom.actualLoadingTime) {
        this.searchFrom.actualLoadingTimeStart = this.searchFrom.actualLoadingTime[0]
        this.searchFrom.actualLoadingTimeEnd = this.searchFrom.actualLoadingTime[1]
      } else {
        this.searchFrom.actualLoadingTimeStart = ''
        this.searchFrom.actualLoadingTimeEnd = ''
      }
      if (this.searchFrom.wayStateArr) {
        this.searchFrom.wayStates = this.searchFrom.wayStateArr.toString()
      } else {
        this.searchFrom.wayStates = ''
      }
      findWayPayeeList(this.searchFrom).then(res => { this.kehuList = res })
    },
    bumenChangeCX (e) {
      let json1 = this.bumenList.filter(item => item.name == e)
      getDepartmentUsers({ subOrgCode: json1[0].code }).then(res => { this.yonghuList = res })
    },
    tabSetting () {
      this.tableMark = true
    },
    // 查询我的页面表头
    queryMyPageField () {
      this.tabHeadList = []
      queryMyPageField({
        // 入参：tagCode 分组编码： 订单列表-> orderPage 运单列表-> wayPage 收支列表-> szPage
        tagCode: this.groupCode
      }).then(res => {
        this.tabHeadList = res
        this.searchList = []
        res.forEach(item => {
          if (item.child.length > 0) {
            item.child.forEach(childItem => {
              if (childItem.isSettingQuery == 1) {
                this.searchList.push(childItem)
              }
            })
          } else {
            if (item.isSettingQuery == 1) {
              this.searchList.push(item)
            }
          }
        })
        this.getHeight()
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
          }
        })
      })
    },
    async exportList (val) {
      let form = { ...this.searchFrom }
      delete form.pageNo
      delete form.pageSize
      form.header = val
      await exportExcel(
        this.global.tmsPlus + '/way/exportRecycleWayList',
        form,
        '回收站运单列表'
      )
      this.isDisable = true
      setTimeout(() => {
        this.isDisable = false // 点击一次时隔两秒后才能再次点击
      }, 2000)
    },
    // 导出
    exportFn () {
      this.exportMark = true
    },

    // 运单
    wayFn (row) {
      this.$router.push({ name: 'qiYunOrderSubPlan', query: { id: row.orderId } })
    },
    // 打印
    dayinFN () {
      let selectData = this.$refs.table.selection
      if (selectData.length != 1) {
        this.$alert('请选择一条要操作的数据', '系统提示')
      } else {
        this.$router.push({ name: 'tmsOrderDayin', query: { id: selectData[0].orderBusinessId } })
      }
    },
    // 详情
    detailFn (row) {
      this.$router.push({ name: 'tmsWayDetails', query: { id: row.wayBusinessId } })
    },
    // 查选
    searchFn () {
      if (this.searchFrom.cargoBarcode) {
        this.searchFrom.cargoBarcodes = this.searchFrom.cargoBarcode.replace(/\n/g, ',')
      } else {
        this.searchFrom.cargoBarcodes = ''
      }
      if (this.searchFrom.createTimes) {
        this.searchFrom.createTimeStart = this.searchFrom.createTimes[0]
        this.searchFrom.createTimeEnd = this.searchFrom.createTimes[1]
      } else {
        this.searchFrom.createTimeStart = ''
        this.searchFrom.createTimeEnd = ''
      }
      if (this.searchFrom.arrivalTimes) {
        this.searchFrom.arrivalTimeStart = this.searchFrom.arrivalTimes[0]
        this.searchFrom.arrivalTimeEnd = this.searchFrom.arrivalTimes[1]
      } else {
        this.searchFrom.arrivalTimeStart = ''
        this.searchFrom.arrivalTimeEnd = ''
      }
      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {
      this.weight = 0
      var that = this
      selection.forEach((item) => {
        // that.weight = (that.weight * 1000 + item.weight * 1000) / 1000
      })
    },
    // 点击选中
    handleRowClick (row, column, event) {
      if (row.orderState != 3) {
        this.$refs.table.toggleRowSelection(row)
      }
    },
    // 获取货物列表
    getList (searchFrom) {
      if (this.searchFrom.wayNo) {
        let wayNoStr = this.searchFrom.wayNo.trim()
        this.searchFrom.wayNos = wayNoStr.replace(/\n/g, ',')
      } else {
        this.searchFrom.wayNos = ''
      }
      if (this.searchFrom.ddbh) {
        let ddhStr = this.searchFrom.ddbh.trim()
        this.searchFrom.orderNos = ddhStr.replace(/\n/g, ',')
      } else {
        this.searchFrom.orderNos = ''
      }
      if (this.searchFrom.cargoBarcode) {
        let kbhStr = this.searchFrom.cargoBarcode.trim()
        this.searchFrom.cargoBarcodes = kbhStr.replace(/\n/g, ',')
      } else {
        this.searchFrom.cargoBarcodes = ''
      }
      if (this.searchFrom.createTimes) {
        this.searchFrom.createTimeStart = this.searchFrom.createTimes[0]
        this.searchFrom.createTimeEnd = this.searchFrom.createTimes[1]
      } else {
        this.searchFrom.createTimeStart = ''
        this.searchFrom.createTimeEnd = ''
      }
      if (this.searchFrom.actualSigningTime) {
        this.searchFrom.actualSigningTimeStart = this.searchFrom.actualSigningTime[0]
        this.searchFrom.actualSigningTimeEnd = this.searchFrom.actualSigningTime[1]
      } else {
        this.searchFrom.actualSigningTimeStart = ''
        this.searchFrom.actualSigningTimeEnd = ''
      }
      if (this.searchFrom.actualLoadingTime) {
        this.searchFrom.actualLoadingTimeStart = this.searchFrom.actualLoadingTime[0]
        this.searchFrom.actualLoadingTimeEnd = this.searchFrom.actualLoadingTime[1]
      } else {
        this.searchFrom.actualLoadingTimeStart = ''
        this.searchFrom.actualLoadingTimeEnd = ''
      }
      if (this.searchFrom.wayStateArr) {
        this.searchFrom.wayStates = this.searchFrom.wayStateArr.toString()
      } else {
        this.searchFrom.wayStates = ''
      }
      findRecycleWayList(searchFrom).then((res) => {
        this.symbolKey = Symbol(new Date().toString())
        this.tableList = []
        res.list.forEach(item => {
          if (item.stowageType == 2) {
            item.children = []
            item.hasChildren = true
          }
          this.tableList.push(item)
        })
        this.total = res.total
      })
    },
    load (tree, treeNode, resolve) {
      findSonSectionList({ orderId: tree.orderId, orderBusinessId: tree.orderBusinessId }).then((res) => {
        resolve(res)
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 重置
    resetForm (formName) {
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50
      }
    },
    // 导入
    THimportFn () {
      this.importDialog = true
    },
    destroy () {
      this.importDialog = false
    },
    DRsave (formData) {
      // const loading = this.$loading({
      //   lock: true,
      //   text: '正在处理...'
      // })
      // impOrder(formData).then(res => {
      //   loading.close()
      //   this.importDialog = false
      //   var that = this
      //   this.importMsg = this.$message({
      //     showClose: true,
      //     message: res,
      //     duration: 0,
      //     type: 'success',
      //     onClose () {
      //       loading.close()
      //     }
      //   })
      //   that.getList(that.searchFrom)
      // }).catch(error => {
      //   this.importMsg = this.$message({
      //     showClose: true,
      //     message: error.message,
      //     duration: 0,
      //     type: 'error',
      //     onClose () {
      //       loading.close()
      //     }
      //   })
      // })
    },
    // 状态格式化
    statusFormat (row, column, cellValue) {
      switch (cellValue) {
        case 1002:
          return '待审核'
        case 1004:
          return '已通过'
        case 1101:
          return '议价中'
        case 1201:
          return '待承运'
        case 1202:
          return '承运中'
        case 1203:
          return '已送达'
        case 1301:
          return '已签收'
        default:
          return '已结算'
      }
    }
  },
  activated () {
    if (!this.$route.meta.isBack) { // 清空查询条件
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50
      }
      this.getList(this.searchFrom)
    } else {
      this.$route.meta.isBack = false
      this.getList(this.searchFrom)
    }
  },
  beforeRouteEnter (to, from, next) {
    if (from.path == '/qiYunOrder/add' || from.path == '/qiYunOrder/edit' || from.path == '/qiYunOrder/details') {
      to.meta.isBack = true
    } else {
      to.meta.isBack = false
    }
    next()
  }
}
</script>

<style scoped lang='less'>
.searchBtnBox{
  margin: 10px 0;
}
.inpBox .el-date-editor{
  width: 430px!important;
}
/deep/ .checkboxBox{
  display: flex;
  label{
    flex-shrink: 0;
  }
  .el-checkbox-group{
    width:250px ;
  }
}
.jiage .el-form-item__content {
  position: relative;
  .identiCode1 {
    position: absolute;
    right: 14px;
    color: #409eff;
  }
  .danwei1 {
    position: absolute;
    right: 14px;
    color: white;
    padding: 7px 4px;
  }
}
.fujianBox{
  display: flex;
  flex-direction: column;
  /deep/.el-button--text{
    text-align: left;
    margin-left: 0;
    margin-bottom: 10px;
  }
}
/deep/.el-form{
  width: 100%;
}
.box{
  width: 100%;
   display: grid;
   grid-template-columns: repeat(auto-fill, 280px);
   grid-auto-flow: row dense;
   /deep/.el-textarea__inner{
    width: 150px;
    height: 68px;
   }
   .item1{
      grid-row-start: span 2;
    }
   .item2{
      grid-column-start: span 2;
      width: 540px;
   }
}
.margin0{
  margin-right: 20px!important;
}
/deep/.el-table .warning-row {
    background: #ffc7c1!important;
  }
// 用于消除固定列下方的伪元素边框线

/deep/ .table {
    .el-table__fixed:before {
      height: 0px;
    }
}
.openBox{
  width: 100%;
}
.openChild{
  width: 50px;
  height: 12px;
  margin: 0 auto;
  border: solid 1px #e4e2e2;
  border-bottom: none;
  background-color: #f5f5f5;
  border-top-right-radius:5px ;
  border-top-left-radius:5px ;
  line-height: 12px;
  text-align: center;
  cursor: pointer;
}
.bottomChild{
  width: 50px;
  height: 12px;
  margin: 0 auto;
  border: solid 1px #e4e2e2;
  border-top: none;
  background-color: #f5f5f5;
  border-bottom-right-radius:5px;
  border-bottom-left-radius:5px;
}
// 由于windows和mac两端系统不一致，el-table滚动条样式渲染的也不同，mac的滚动条要比windows的窄一些，我这边做了高度差
/*CSS 本身不能检测操作系统，但可以检测浏览器的引擎。Mac 和 Windows 的默认浏览器（Safari 和 Edge/Chrome）使用不同的引擎（WebKit 和 Blink），可以利用 @supports 规则来实现不同样式。不过，这种方法不是完全可靠，因为它依赖于特定的引擎行为。*/
/* 针对 WebKit 浏览器 (可能是 Windows) */
@supports (-webkit-touch-callout: none) {
  /deep/ .table .el-table__fixed {
      height: calc(100% - 20px) !important;
  }
}

/* 针对非 WebKit 浏览器 (可能是 Mac) */
@supports not (-webkit-touch-callout: none) {
  /deep/ .table .el-table__fixed {
      height: calc(100% - 12px) !important;
  }
}

</style>
